import { SgButton } from '../SgButton';
import { useSgPickerInputContext } from './context';
import type { SgPickerItem } from './types';

type SelectedBadgesProps = {
  item: SgPickerItem;
  isLast?: boolean;
  isHidden?: boolean;
};

export function SelectedBadges({ item, isLast = false, isHidden = false }: SelectedBadgesProps) {
  const { size, disabled, readonly, getToggleButtonProps, removeSelectedItem } = useSgPickerInputContext();

  const handleClear = () => {
    if (removeSelectedItem) {
      removeSelectedItem(item);
    }
  };

  return (
    <div
      className={`badge-item bg-lvl1 flex-center item badge badge-dismissible badge-default sgbs-badge-default me-1 mt-1 badge-${size} overflow-hidden ${isLast ? 'me-12px' : ''}`}
      style={isHidden ? { display: 'none' } : undefined}
    >
      <SgButton
        className="text-secondary"
        purpose="link"
        iconPosition="icon-only"
        size={size}
        icon="close"
        onClick={handleClear}
        aria-label="remove item"
        disabled={disabled || readonly}
      />
      <span {...(disabled || readonly ? {} : getToggleButtonProps())}>{item.label}</span>
    </div>
  );
}
